import { StatusProcessamentoIA, TipoProcessamentoIA, EntidadeReferenciaProcessamentoIA, } from '../generated/backend-enums.js';
export { StatusProcessamentoIA, TipoProcessamentoIA, EntidadeReferenciaProcessamentoIA };
export const StatusProcessamentoIAMap = {
    [StatusProcessamentoIA.PENDENTE]: 'Pendente',
    [StatusProcessamentoIA.CONCLUIDO]: 'Concluído',
    [StatusProcessamentoIA.FALHA]: 'Falha',
};
export const TipoProcessamentoIAMap = {
    [TipoProcessamentoIA.ANALISE_BRIEFING]: 'Análise de briefing',
    [TipoProcessamentoIA.VERSAO_ITENS]: 'Versão de itens',
    [TipoProcessamentoIA.PREDICAO_RENTABILIDADE]: 'Predição de rentabilidade',
    [TipoProcessamentoIA.AREA_DETECTION]: 'Detecção de áreas',
};
export const EntidadeReferenciaProcessamentoIAMap = {
    [EntidadeReferenciaProcessamentoIA.JOB]: 'Job',
    [EntidadeReferenciaProcessamentoIA.VERSAO]: 'Versão',
};
